import { createBrowserHistory } from "history";

import { ROOT_PATH } from "../constants";

export default createBrowserHistory({ basename: ROOT_PATH });
